import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { absUrl } from "../blocks/media";
import { renderInline } from "../blocks/renderInline";

export const BUSINESSES_DEFAULTS = {
  eyebrow: "For businesses · Gig Harbor to Olympia", title: "Add a Gem —", badge: "FREE",
  body: "One form, five minutes. Priority entries by **Nov 11** make the first Map of Gems on Nov 13.",
  benefits: [
    { icon: "MapPin", title: "On the map, for free", body: "Your Gem — a deal, special or gift — lands on the Holiday HOPE Hop map and in THE HOARD. No fees, ever." },
    { icon: "ShieldCheck", title: "Safer rooms, stronger trust", body: "Carry the North Star drink-spiking guide. Customers see a business that looks out for them." },
    { icon: "Megaphone", title: "Promotion done for you", body: "Featured on THE WALL, in the season calendar and in partner outreach — we do the posting." },
  ],
  cta_label: "Add your Gem", cta_url: "/for-businesses", image: "/images/for-biz/trove-map.png", image_url: "/hoard",
};

export const HomeBusinesses = ({ block }) => {
  const cfg = { ...BUSINESSES_DEFAULTS, ...(block?.config || {}) };
  return (
    <section className="bg-[#F9F8F6] py-14 sm:py-20" data-testid="for-businesses-section">
      <div className={`max-w-7xl mx-auto px-6 md:px-12 grid gap-10 items-center ${cfg.image ? "lg:grid-cols-[1fr_1.1fr]" : ""}`}>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#E76F51]">{cfg.eyebrow}</p>
          <h2 className="mt-2 font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#2E5C55] leading-tight">{block?.title || cfg.title} {cfg.badge && <span className="rounded-lg bg-[#F2CC8F] px-2 text-[#1A1A1A]">{cfg.badge}</span>}</h2>
          <p className="mt-3 text-base text-[#5C5C5C] max-w-xl [&_strong]:text-[#1A1A1A]">{renderInline(block?.quip || cfg.body)}</p>
          <ul className="mt-6 space-y-4">
            {(cfg.benefits || []).map((b, i) => {
              const Icon = Icons[b.icon] || Icons.Sparkles;
              return (
                <li key={i} className="flex gap-4 rounded-2xl bg-white border border-[#2E5C55]/15 p-4 shadow-sm" data-testid={`biz-benefit-${i + 1}`}>
                  <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#E76F51] text-white"><Icon className="h-5 w-5" /></span>
                  <span><span className="block font-extrabold text-[#1A1A1A]">{b.title}</span><span className="block text-sm text-[#5C5C5C] leading-snug">{b.body}</span></span>
                </li>
              );
            })}
          </ul>
          {cfg.cta_label && <Link to={cfg.cta_url} className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#2E5C55] px-5 py-3 text-sm font-bold text-white hover:bg-[#244a44] active:scale-95 transition-[background-color,transform] shadow-md" data-testid="add-gem-cta-button"><Icons.Gem className="h-4 w-4" /> {cfg.cta_label} <Icons.ArrowRight className="h-4 w-4" /></Link>}
        </div>
        {cfg.image && (
          <Link to={cfg.image_url || cfg.cta_url} className="block rounded-2xl overflow-hidden border border-[#2E5C55]/15 shadow-md hover:-translate-y-0.5 transition-transform" data-testid="biz-map-preview">
            <img src={absUrl(cfg.image)} alt="" className="w-full h-auto" loading="lazy" />
          </Link>
        )}
      </div>
    </section>
  );
};
